import * as React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { useShoppingListById } from '../../../hooks/use-shopping-list-by-id.js';
import { getWishlisted } from '../utils/get-wishlisted.js';

const AnonymousWishlistButton = ({ sku , localWishlistId , isUpdateLoading , onWishlistClick , clearLocalWishlist , disabled  })=>{
    const { data , loading  } = useShoppingListById(clearLocalWishlist, localWishlistId);
    const isWishlisted = getWishlisted(sku, data === null || data === void 0 ? void 0 : data.items);
    const { getLabel  } = useIntl();
    const isDisabled = loading || disabled;
    const wishlistButtonAriaLabel = isWishlisted ? getLabel('account.wishlist.buttonLabel.remove') : getLabel('account.wishlist.buttonLabel.add');
    return /*#__PURE__*/ React.createElement("button", {
        onClick: (event)=>{
            onWishlistClick(isWishlisted ? 'remove' : 'add', localWishlistId, event);
        },
        disabled: isDisabled,
        className: classnames('wishlist-button', {
            'wishlist-button--disabled': isDisabled,
            'wishlist-button--wishlisted': isWishlisted || isUpdateLoading
        }),
        "aria-disabled": isDisabled,
        "aria-label": wishlistButtonAriaLabel
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: isWishlisted || isUpdateLoading ? 'favourite-filled' : 'favourite-empty'
    }));
};

export { AnonymousWishlistButton as default };
//# sourceMappingURL=AnonymousWishlistButton.js.map
